import { connectRouter } from "connected-react-router/immutable";
import { combineReducers } from "redux-immutable";

import * as customDeliveryDocketPrintModalAttachmentsSection from "@/components/CustomDeliveryDocketPrintModal/AttachmentsSection/redux";
import * as customDeliveryDocketPrintModalProductsSection from "@/components/CustomDeliveryDocketPrintModal/ProductsSection/redux";
/** Custom Delivery Docket */
import * as customDeliveryDocketPrintModal from "@/components/CustomDeliveryDocketPrintModal/redux";
import * as customWorkOrderPrintModalAttachmentsSection from "@/components/CustomWorkOrderPrintModal/AttachmentsSection/redux";
import * as customWorkOrderPrintModalProductsSection from "@/components/CustomWorkOrderPrintModal/ProductsSection/redux";
/** End of Custom Delivery Docket */
/** Custom Work Order */
import * as customWorkOrderPrintModal from "@/components/CustomWorkOrderPrintModal/redux";
/** End of Custom Work Order */
import * as paymentStatusActions from "@/components/new/PaymentStatus/payment-status.actions";
import * as salesOrderInvoicingCreateActions from "@/components/new/SalesOrderInvoicing/CreateInvoiceModal/create-invoice.actions";
import * as salesOrderInvoicingCreatePartialActions from "@/components/new/SalesOrderInvoicing/CreatePartialInvoiceModal/create-partial-invoice.actions";
import * as salesOrderInvoicingCreateProformaActions from "@/components/new/SalesOrderInvoicing/CreateProformaInvoiceModal/create-proforma-invoice.actions";
import * as salesOrderInvoicingFtueActions from "@/components/new/SalesOrderInvoicing/FirstTimeUserExperienceModal/first-time-user-experience.actions";
import createAdditionalProductsWrapper from "@/redux/additional-products-wrappers";
import { createNamespacedReducer } from "@/redux/utils/reducer";

import history from "../app/history";

import * as accounting from "./accounting";
import * as addLabourLineItems from "./add-labour-line-items";
import * as addProductToKitInline from "./add-product-to-kit-inline";
import * as addProductToOrderInline from "./add-product-to-order-inline";
import alertsReducer from "./alerts/alerts.reducer";
import * as assignees from "./assignees";
import * as authenticationActions from "./authentication/authentication.actions";
import authenticationReducer from "./authentication/authentication.reducer";
import * as collaborateLabels from "./collaborateLabels";
import * as collaboration from "./collaboration";
import customersReducer from "./customers/customers.reducer";
import * as dashboard from "./dashboard";
import * as addWidgets from "./dashboard/add-widgets";
import * as deliveryScheduling from "./deliveryScheduling";
import * as dynamicTableViews from "./dynamic-table-views";
import * as forgotPassword from "./forgotPassword";
import * as generatePdf from "./generate-pdf";
import * as globalSearch from "./globalSearch";
import * as importCustomers from "./importCustomers";
import * as importSuppliers from "./importSuppliers";
import * as labels from "./labels";
import linkedOrdersReducer from "./linkedOrders/linkedOrders.reducer";
import loadingReducer from "./loading/loading.reducer";
import * as materialsv2 from "./materials";
import additionalProducts from "./modules/additional-products";
import alerts from "./modules/alerts";
import auth from "./modules/auth";
import calendar from "./modules/calendar";
import cards from "./modules/cards";
import collaborationNotes from "./modules/collaboration-notes";
import customers from "./modules/customers";
import drawings from "./modules/drawings";
import drawingsItems from "./modules/drawings-items";
import drawingsProducts from "./modules/drawings-products";
import flashingProducts from "./modules/flashing-products";
import materials from "./modules/materials";
import orders from "./modules/orders";
import prices from "./modules/prices";
import purchase from "./modules/purchase";
import newRootReducers from "./newRootReducers";
import * as notifications from "./notifications";
import * as orderAddLabourLineItem from "./orderAddLabourLineItem";
import * as orderAttachments from "./orderAttachments";
import * as orderChecklists from "./orderChecklists";
import * as orderChecklistTemplates from "./orderChecklistTemplates";
import * as orderTimeline from "./orderTimeline";
import * as orderTracking from "./orderTracking";
import * as timeTracking from "./orderTracking/timeTracking";
import * as activeTimeEntries from "./orderTracking/timeTracking/activeTimeEntries";
import * as hoursScheduled from "./orderTracking/timeTracking/hoursScheduled";
import * as hoursWorked from "./orderTracking/timeTracking/hoursWorked";
import * as partialInvoice from "./partialInvoice";
import * as pdfCustomisation from "./pdf-customisation";
import * as planner from "./planner";
import * as plannerAlerts from "./planner/alerts/redux";
import * as plannerCalendar from "./planner/calendar";
import * as plannerDrawer from "./planner/drawer/redux";
import * as plannerLabelFilter from "./planner/labelFilter";
import * as plannerOrders from "./planner/orders";
import * as plannerProgressFilter from "./planner/progressFilter";
import * as plannerRequiredDateFilter from "./planner/requiredDateFilter";
import * as plannerScheduleStateFilter from "./planner/scheduleStateFilter";
import * as plannerSearchFilter from "./planner/searchFilter";
import * as plannerStatusFilter from "./planner/statusFilter";
import * as plannerUserFilter from "./planner/userFilter";
import { preferencesActions } from "./preferences/preferences.actions";
import preferencesReducer from "./preferences/preferences.reducer";
import * as priceLevels from "./priceLevels";
import * as productCatalogue from "./productCatalogue";
import * as productKits from "./productKits";
import * as productsActions from "./products/products.actions";
import productsReducer from "./products/products.reducer";
import * as purchaseOrderProductLists from "./purchaseOrders/productLists";
import purchaseOrdersReducer from "./purchaseOrders/purchaseOrders.reducer";
import * as purchaseOrderTimeline from "./purchaseOrderTimeline";
import * as salesOrder from "./sales-order";
import * as salesOrderPageFilter from "./sales-order/page-filter";
import * as salesOrderSearchFilter from "./sales-order/search-filter";
import * as salesOrderSort from "./sales-order/sort";
import * as billingSettings from "./settings/billing";
import * as teamsSettings from "./settings/teams";
import * as signup from "./signup";
import * as splitOrders from "./splitOrders";
import * as splitPurchaseOrders from "./splitPurchaseOrders";
import * as stocktake from "./stocktake";
import * as stocktakeSearchFilter from "./stocktake/searchFilter";
import * as stocktakeSupplierFilter from "./stocktake/supplierFilter";
import supplierProductsReducer from "./supplierProducts/supplierProducts.reducer";
import suppliersReducer from "./suppliers/suppliers.reducer";
import supplierSettingsReducer from "./suppliers-settings/suppliers-settings.reducer";
import * as timesheets from "./timesheets";
import * as individualTimesheets from "./timesheets/individualTimesheets";
import * as pinConfirmationTimesheets from "./timesheets/pinConfirmation";
import * as timeheetsTimeEntry from "./timesheets/timeEntry";
import * as timezones from "./timezones";
import * as users from "./users";
import * as views from "./views";
import * as workflow from "./workflow";
import * as workflowChildCardFilter from "./workflow/childCardFilter";
import * as workflowLabelFilter from "./workflow/labelFilter";
import * as workflowRequiredDateFilter from "./workflow/requiredDateFilter";
import * as workflowSearchFilter from "./workflow/searchFilter";
import * as workflowSortFilter from "./workflow/sortFilter";
import * as workflowUserFilter from "./workflow/userFilter";

export const allReducers = combineReducers({
  // OLD REDUCERS //
  alerts: alerts.reducers,
  customers: customers.reducers,
  orders: orders.reducers,
  prices: prices.reducers,
  drawings: drawings.reducers,
  drawingsProducts: drawingsProducts.reducers,
  drawingsItems: drawingsItems.reducers,
  additionalProducts: createAdditionalProductsWrapper(additionalProducts.reducers),
  flashingProducts: flashingProducts.reducers,
  materials: materials.reducers,
  cards: cards.reducers,
  calendar: calendar.reducers,
  collaborationNotes: collaborationNotes.reducers,
  purchase: purchase.reducers,

  // NEW REDUCERS //
  [signup.MODULE]: signup.reducer,
  authentication: authenticationReducer,
  preferences: preferencesReducer,
  suppliers: suppliersReducer,
  products: productsReducer,
  [materialsv2.MODULE]: materialsv2.reducer,
  supplierProducts: supplierProductsReducer,
  purchaseOrders: purchaseOrdersReducer,
  customersv2: customersReducer,
  salesOrders: linkedOrdersReducer,
  supplierSettings: supplierSettingsReducer,
  [customWorkOrderPrintModalAttachmentsSection.MODULE]:
    customWorkOrderPrintModalAttachmentsSection.reducer,
  [customWorkOrderPrintModal.MODULE]: customWorkOrderPrintModal.reducer,
  [customWorkOrderPrintModalProductsSection.MODULE]:
    customWorkOrderPrintModalProductsSection.reducer,
  [customDeliveryDocketPrintModal.MODULE]: customDeliveryDocketPrintModal.reducer,
  [customDeliveryDocketPrintModalAttachmentsSection.MODULE]:
    customDeliveryDocketPrintModalAttachmentsSection.reducer,
  [customDeliveryDocketPrintModalProductsSection.MODULE]:
    customDeliveryDocketPrintModalProductsSection.reducer,
  [accounting.MODULE]: accounting.reducer,
  [productCatalogue.MODULE]: productCatalogue.reducer,
  [stocktake.MODULE]: stocktake.reducer,
  [stocktakeSupplierFilter.MODULE]: stocktakeSupplierFilter.reducer,
  [stocktakeSearchFilter.MODULE]: stocktakeSearchFilter.reducer,
  [productKits.MODULE]: productKits.reducer,
  [workflow.MODULE]: workflow.reducer,
  [workflowSearchFilter.MODULE]: workflowSearchFilter.reducer,
  [workflowSortFilter.MODULE]: workflowSortFilter.reducer,
  [workflowUserFilter.MODULE]: workflowUserFilter.reducer,
  [workflowLabelFilter.MODULE]: workflowLabelFilter.reducer,
  [workflowRequiredDateFilter.MODULE]: workflowRequiredDateFilter.reducer,
  [workflowChildCardFilter.MODULE]: workflowChildCardFilter.reducer,
  [orderAttachments.MODULE]: orderAttachments.reducer,
  [orderChecklists.MODULE]: orderChecklists.reducer,
  [orderChecklistTemplates.MODULE]: orderChecklistTemplates.reducer,
  [orderTimeline.MODULE]: orderTimeline.reducer,
  [orderTracking.MODULE]: orderTracking.reducer,
  [timeTracking.MODULE]: timeTracking.reducer,
  [hoursWorked.MODULE]: hoursWorked.reducer,
  [hoursScheduled.MODULE]: hoursScheduled.reducer,
  [activeTimeEntries.MODULE]: activeTimeEntries.reducer,
  [timesheets.MODULE]: timesheets.reducer,
  [individualTimesheets.MODULE]: individualTimesheets.reducer,
  [pinConfirmationTimesheets.MODULE]: pinConfirmationTimesheets.reducer,
  [timeheetsTimeEntry.MODULE]: timeheetsTimeEntry.reducer,
  [orderAddLabourLineItem.MODULE]: orderAddLabourLineItem.reducer,
  [purchaseOrderTimeline.MODULE]: purchaseOrderTimeline.reducer,
  [partialInvoice.MODULE]: partialInvoice.reducer,
  [splitOrders.MODULE]: splitOrders.reducer,
  [splitPurchaseOrders.MODULE]: splitPurchaseOrders.reducer,

  [views.MODULE]: views.reducer,
  [users.MODULE]: users.reducer,
  [labels.MODULE]: labels.reducer,
  [assignees.MODULE]: assignees.reducer,
  [planner.MODULE]: planner.reducer,
  [plannerCalendar.MODULE]: plannerCalendar.reducer,
  [plannerDrawer.MODULE]: plannerDrawer.reducer,
  [plannerAlerts.MODULE]: plannerAlerts.reducer,
  [plannerOrders.MODULE]: plannerOrders.reducer,
  [plannerUserFilter.MODULE]: plannerUserFilter.reducer,
  [plannerProgressFilter.MODULE]: plannerProgressFilter.reducer,
  [plannerLabelFilter.MODULE]: plannerLabelFilter.reducer,
  [plannerRequiredDateFilter.MODULE]: plannerRequiredDateFilter.reducer,
  [plannerSearchFilter.MODULE]: plannerSearchFilter.reducer,
  [plannerScheduleStateFilter.MODULE]: plannerScheduleStateFilter.reducer,
  [plannerStatusFilter.MODULE]: plannerStatusFilter.reducer,
  [priceLevels.MODULE]: priceLevels.reducer,
  ...deliveryScheduling.reducer(),
  ...pdfCustomisation.reducer(),
  [generatePdf.MODULE]: generatePdf.reducer,
  [importSuppliers.MODULE]: importSuppliers.reducer,
  [importCustomers.MODULE]: importCustomers.reducer,
  [forgotPassword.MODULE]: forgotPassword.reducer,
  [dashboard.MODULE]: dashboard.reducer,
  [addWidgets.MODULE]: addWidgets.reducer,
  [teamsSettings.MODULE]: teamsSettings.reducer,
  [billingSettings.MODULE]: billingSettings.reducer,
  [addProductToOrderInline.MODULE]: addProductToOrderInline.reducer,
  [addProductToKitInline.MODULE]: addProductToKitInline.reducer,
  [purchaseOrderProductLists.MODULE]: purchaseOrderProductLists.reducer,
  [addLabourLineItems.MODULE]: addLabourLineItems.reducer,
  [timezones.MODULE]: timezones.reducer,
  [notifications.MODULE]: notifications.reducer,
  [salesOrder.MODULE]: salesOrder.reducer,
  [salesOrderSearchFilter.MODULE]: salesOrderSearchFilter.reducer,
  [salesOrderPageFilter.MODULE]: salesOrderPageFilter.reducer,
  [salesOrderSort.MODULE]: salesOrderSort.reducer,
  [dynamicTableViews.MODULE]: dynamicTableViews.reducer,
  [collaborateLabels.MODULE]: collaborateLabels.reducer,
  alertsv2: alertsReducer,
  loading: loadingReducer,
  router: connectRouter(history),
  ...createNamespacedReducer({
    reducer: globalSearch.reducer,
    module: globalSearch.MODULE,
    namespace: "globalSearch",
  }),
  ...createNamespacedReducer({
    reducer: globalSearch.reducer,
    module: globalSearch.MODULE,
    namespace: "salesOrder",
  }),
  ...createNamespacedReducer({
    reducer: globalSearch.reducer,
    module: globalSearch.MODULE,
    namespace: "purchaseOrder",
  }),
  ...createNamespacedReducer({
    reducer: collaboration.reducer,
    module: collaboration.MODULE,
    namespace: collaboration.constants.NAMESPACES.ORDER,
  }),
  ...createNamespacedReducer({
    reducer: collaboration.reducer,
    module: collaboration.MODULE,
    namespace: collaboration.constants.NAMESPACES.PURCHASE_ORDER,
  }),
  ...createNamespacedReducer({
    reducer: collaboration.reducer,
    module: collaboration.MODULE,
    namespace: collaboration.constants.NAMESPACES.SUPPLIER,
  }),
  ...createNamespacedReducer({
    reducer: collaboration.reducer,
    module: collaboration.MODULE,
    namespace: collaboration.constants.NAMESPACES.CUSTOMER,
  }),
  ...createNamespacedReducer({
    reducer: collaboration.reducer,
    module: collaboration.MODULE,
    namespace: collaboration.constants.NAMESPACES.PRODUCT,
  }),
  [collaborateLabels.MODULE]: collaborateLabels.reducer,

  ...newRootReducers,
});

export const rootActions = Object.assign(
  {},
  { auth: auth.actions },
  { authentication: authenticationActions },
  { alerts: alerts.actions },
  { customers: customers.actions },
  { orders: orders.actions },
  { prices: prices.actions },
  { drawings: drawings.actions },
  { drawingsProducts: drawingsProducts.actions },
  { drawingsItems: drawingsItems.actions },
  { additionalProducts: additionalProducts.actions },
  { flashingProducts: flashingProducts.actions },
  { materials: materials.actions },
  { cards: cards.actions },
  { calendar: calendar.actions },
  { collaborationNotes: collaborationNotes.actions },
  { purchase: purchase.actions },
  { preferences: preferencesActions },
  { workflow: workflow.actions },
  { products: productsActions },
  { productKits: productKits.actions },
  { orderTimeline: orderTimeline.actions },
  { orderChecklists: orderChecklists.actions },
  { orderChecklistTemplates: orderChecklistTemplates.actions },
  { orderAddLabourLineItem: orderAddLabourLineItem.actions },
  { purchaseOrderTimeline: purchaseOrderTimeline.actions },
  { addProductToOrderInline: addProductToOrderInline.actions },
  { addProductToKitInline: addProductToKitInline.actions },
  { generatePdf: generatePdf.actions },
  { paymentStatus: paymentStatusActions },
  { salesOrderInvoicingFtue: salesOrderInvoicingFtueActions },
  { salesOrderInvoicingCreate: salesOrderInvoicingCreateActions },
  { salesOrderInvoicingCreateProforma: salesOrderInvoicingCreateProformaActions },
  { salesOrderInvoicingCreatePartial: salesOrderInvoicingCreatePartialActions }
);

export const rootReducers = (state, action) => {
  const nextState = action.type === "RESET_APP" ? undefined : state;
  return allReducers(nextState, action);
};
